import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'

export const CleanersAdminUploadSchedule = async (AuthData,Authstr) => {
    const getUrl = environmentConfig();
    const requestUrl = getUrl + ConstantsBase.UploadCleanerSchedule+AuthData.UserId;
  
    try {
      const data = await axios({
        method: 'post',
        url: requestUrl,
        data: AuthData.Data,
        headers: { 'Content-Type': 'application/json;' ,Authorization :Authstr,FileName:AuthData.FileName },
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
    }
  
    catch (e) {
      return e;
    }
  }